import axios from 'axios'

export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    getOffersReport(params) {
        return axios.get('/reports/offers', {
          params: params
        }).then(response => this.checkResponse(response))
    },
    getSourcesForSelect() {
        return axios.get('/sources/select-list')
            .then(response => {

                return this.checkResponse(response);
            })
    },
    getUsersReport(page, sort, search, range, user, pageSize, group, source, type, isTest, application_owner) {
        var url = '/reports/users?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc
                + '&start=' + range.start + '&end=' + range.end + '&user=' + user + '&search=' + search
                + '&pageSize=' + pageSize + '&group=' + group + '&source=' + source + '&isTest=' + isTest
                + '&type=' + type;
        url+= '&application_owner=' + application_owner;
        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getSourcesReport(page, sort, search, range, user, pageSize, group, source, type, isTest, application_owner) {
        var url = '/reports/sources?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc
                + '&start=' + range.start + '&end=' + range.end + '&user=' + user + '&search=' + search
                + '&pageSize=' + pageSize + '&group=' + group + '&source=' + source + '&isTest=' + isTest
                + '&type=' + type;
        url+= '&application_owner=' + application_owner;
        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getDateReport(page, sort, search, range, user, pageSize, group, source, type, isTest, application_owner) {
        var url = '/reports/date?page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc
                + '&start=' + range.start + '&end=' + range.end + '&user=' + user
                + '&search=' + search + '&pageSize=' + pageSize + '&group=' + group + '&source=' + source
                + '&isTest=' + isTest  + '&type=' + type;
        url+= '&application_owner=' + application_owner;
        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getSumValues(reports) {
        let sumRevenueUsd = 0;
        let sumExpenseWithDiscountUsd = 0;
        let sumLeadsCount = 0;
        let sumExpenseUsd = 0;
        let sumDiscount = 0;

        reports.forEach(function (report) {
            sumRevenueUsd = sumRevenueUsd + parseFloat(report.revenue_usd)
            sumExpenseUsd = sumExpenseUsd + parseFloat(report.expense_usd)
            sumDiscount = sumDiscount + parseFloat(report.discount_usd)
            sumExpenseWithDiscountUsd = sumExpenseWithDiscountUsd + parseFloat(report.expense_with_discount_usd)
            sumLeadsCount = sumLeadsCount + parseFloat(report.leads_count)
        });
        sumRevenueUsd = Math.round(sumRevenueUsd * 100) / 100;
        sumExpenseWithDiscountUsd = Math.round(sumExpenseWithDiscountUsd * 100) / 100;
        sumLeadsCount = Math.round(sumLeadsCount * 100) / 100;
        sumExpenseUsd = Math.round(sumExpenseUsd * 100) / 100;
        sumDiscount = Math.round(sumDiscount * 100) / 100;

        let sumProfit = sumRevenueUsd - sumExpenseWithDiscountUsd;

        sumProfit = Math.round(sumProfit * 100) / 100;

        let sumRoi = 0;
        let sumGmRev = 0;

        if (sumProfit != 0) {
            sumRoi = (sumProfit / sumExpenseWithDiscountUsd) * 100;
            sumGmRev = (sumProfit / sumRevenueUsd) * 100;

            sumRoi = Math.round(sumRoi * 100) / 100;
            sumGmRev = Math.round(sumGmRev * 100) / 100;
        }

        return {
            sumExpenseWithDiscountUsd: sumExpenseWithDiscountUsd,
            sumRevenueUsd: sumRevenueUsd,
            sumProfit: sumProfit,
            sumRoi: sumRoi,
            sumLeadsCount: sumLeadsCount,
            sumExpenseUsd: sumExpenseUsd,
            sumDiscount: sumDiscount,
            sumGmRev: sumGmRev
        };
    },
    getCustomReport(page, sort, pageSize, columns, filters) {
        let params = 'page=' + page + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc + '&start='
            + filters.range.start + '&end=' + filters.range.end + '&user='
            + filters.userArray + '&search=' + filters.searchArray + '&pageSize=' + pageSize + '&group='
            + filters.group + '&source=' + filters.sourceArray + '&isTest=' + filters.isTest + '&columns=' + columns
            + '&selectedExpenseCurrency=' + filters.selectedExpenseCurrency + '&selectedRevenueCurrency='
            + filters.selectedRevenueCurrency + '&selectedAffisePlatform=' + filters.selectedAffisePlatform
            + '&selectedPlatforms=' + filters.selectedPlatforms + '&selectedTracker=' + filters.selectedTracker
            + '&selectedPartnerId=' + filters.selectedPartnerId
            + '&selectedAdvertiser=' + filters.selectedAdvertiser
            + '&selectedSub1=' + filters.selectedSub1 + '&selectedSub2=' + filters.selectedSub2
            + '&selectedSub3=' + filters.selectedSub3 + '&selectedSub4=' + filters.selectedSub4
            + '&type=' + filters.type + '&application_owner=' + filters.application_owner
            + '&salesManagers=' + filters.salesManagers
            + '&accountManagers=' + filters.accountManagers
            + '&channel=' + filters.channel

        let url = '/reports/custom?' + params;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    saveTemplate(columns, filters, newTemplateTitle) {
        let params = 'start='
            + filters.range.start + '&end=' + filters.range.end + '&user='
            + filters.userArray + '&search=' + filters.searchArray + '&group='
            + filters.group + '&source=' + filters.sourceArray + '&isTest=' + filters.isTest + '&columns=' + columns
            + '&selectedExpenseCurrency=' + filters.selectedExpenseCurrency + '&selectedRevenueCurrency='
            + filters.selectedRevenueCurrency + '&selectedAffisePlatform=' + filters.selectedAffisePlatform
            + '&selectedPlatforms=' + filters.selectedPlatforms + '&selectedTracker=' + filters.selectedTracker
            + '&selectedPartnerId=' + filters.selectedPartnerId
            + '&selectedAdvertiser=' + filters.selectedAdvertiser
            + '&selectedSub1=' + filters.selectedSub1 + '&selectedSub2=' + filters.selectedSub2
            + '&selectedSub3=' + filters.selectedSub3 + '&selectedSub4=' + filters.selectedSub4
            + '&type=' + filters.type + '&application_owner=' + filters.application_owner
            + '&salesManagers=' + filters.salesManagers
            + '&accountManagers=' + filters.accountManagers

        return axios.post('/templates/save', {
            'params_string': params,
            'date_from': filters.range.start,
            'date_to': filters.range.end,
            'title': newTemplateTitle
        }).then(response => {

            return this.checkResponse(response)
        })
    },
    getTemplates() {

        return axios.get('/templates/list')
            .then(response => {

                return this.checkResponse(response);
            })
    },
    deleteTemplate(id) {
        return axios.post('/templates/delete/' + id)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    showTemplate(params) {
        return axios.get('/reports/custom?' + params)
            .then(response => {

                return this.checkResponse(response);
            })
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/reportsDataService.js